// @flow
/* global localStorage */
import React from 'react';
import QuoteStep from '../enums/QuoteStep';
import useAppStateStore from '../../../shared/store/AppStateStore';

const ExplanationModal = () => {
  const STATE = useAppStateStore();

  if (!STATE.isExplanationModal) return null;

  const closeExplanationModal = () => {
    STATE.setIsExplanationModal(false);
  };

  let policyDetails = null;
  try {
    const policyDetailsString =
      typeof localStorage !== 'undefined'
        ? localStorage.getItem('policyDetails')
        : null;
    policyDetails = policyDetailsString
      ? JSON.parse(policyDetailsString)
      : null;
  } catch (error) {
    policyDetails = null;
  }

  const features =
    policyDetails?.uberpolicies?.AllSchemeFeatureDescriptions ?? [];

  // Find the first matching feature for the current modal heading
  const matchingFeature = features.find(
    feature => feature?.featureName === STATE.modalHeading
  );

  return (
    <>
      {STATE.currentStep === QuoteStep.TQ_PANEL && STATE.isExplanationModal && (
        <>
          <div
            className="tw-fixed tw-inset-0 tw-h-screen tw-w-full"
            onClick={e => {
              if (e.target === e.currentTarget) {
                closeExplanationModal();
              }
            }}
          ></div>
          <div className="tw-fixed tw-bottom-0 tw-z-[1] tw-w-full tw-overflow-hidden max-[1023px]:tw-block min-[1024px]:tw-hidden">
            <div id="myModal" className="modal">
              <div className="tw-fixed tw-bottom-0 tw-left-0 tw-h-[60vh] tw-w-full tw-overflow-y-auto tw-rounded-t-[15px] tw-border tw-border-white tw-bg-white tw-shadow-[0_4px_8px_0_rgba(0,0,0,0.2),0_6px_20px_0_rgba(0,0,0,0.19)] tw-animate-modal-slide-in">
                <div className="tw-flex tw-items-center tw-justify-between tw-border-x-0 tw-border-t-0 tw-border-b tw-border-solid tw-border-[#e8e8e8] tw-bg-white tw-px-5 tw-py-3">
                  {STATE.modalHeading === 'Additional Excesses' ? (
                    <h1 className="tw-m-0 tw-text-dis-navy">Excess</h1>
                  ) : (
                    <h1 className="tw-m-0 tw-text-dis-navy">
                      {STATE.modalHeading}
                    </h1>
                  )}
                  <span
                    onClick={closeExplanationModal}
                    className="tw-cursor-pointer tw-text-[32px] tw-text-[#0d223f]"
                  >
                    &times;
                  </span>
                </div>
                <div className="tw-bg-white tw-p-[15px]">
                  {matchingFeature?.schemeFeatureDefinition ? (
                    <div>
                      <p className="tw-text-sm">
                        {matchingFeature.schemeFeatureDefinition}
                      </p>

                      {/* Map through schemeDescriptions */}
                      {Object.entries(
                        matchingFeature.schemeDescriptions ?? {}
                      ).map(([sectionTitle, descriptions], index) => (
                        <div key={index}>
                          <div className="tw-border-x-0 tw-border-t-0 tw-border-b tw-border-solid tw-border-[#eee] tw-break-words tw-px-[5px]">
                            <p className="tw-font-bold tw-text-sm">
                              {sectionTitle}
                            </p>
                          </div>
                          {descriptions?.map((desc, i) => {
                            // Handle descriptions with "##-##" separator
                            if (desc?.includes('##-##')) {
                              const [part1, part2] = desc.split('##-##');
                              return (
                                <div
                                  key={i}
                                  className="tw-flex tw-items-start tw-justify-between tw-border-x-0 tw-border-t-0 tw-border-b tw-border-solid tw-border-[#eee]"
                                >
                                  <p className="tw-break-words tw-px-[5px] tw-font-normal tw-text-sm">
                                    {part1?.trim()}
                                  </p>
                                  <p className="tw-min-w-[51px] tw-break-words tw-px-[5px] tw-font-normal tw-text-sm">
                                    {part2?.trim()}
                                  </p>
                                </div>
                              );
                            }
                            // Regular description without separator
                            return (
                              <div
                                key={i}
                                className="tw-border-x-0 tw-border-t-0 tw-border-b tw-border-solid tw-border-[#eee]"
                              >
                                <p className="tw-break-words tw-px-[5px] tw-font-normal tw-text-sm">
                                  {desc}
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p>No information available for this feature.</p>
                  )}
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ExplanationModal;
